import { createSlice } from "@reduxjs/toolkit";

export const userAuth = createSlice({
  name: "userAuth",
  initialState: {
    isAuthenticated: false,
  },
  reducers: {
    setIsAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload;
    },
  },
});

export const { setIsAuthenticated } = userAuth.actions;

export default userAuth.reducer;
